export const SHOW_CALENDAR_FILTER = 'SHOW_CALENDAR_FILTER'
export const HIDE_CALENDAR_FILTER = 'HIDE_CALENDAR_FILTER'
export const CHANGE_CALENDAR_FILTER_VALUE = 'CHANGE_CALENDAR_FILTER_VALUE'
export const SHOW_ADD_TO_CALENDAR_MENU = 'SHOW_ADD_TO_CALENDAR_MENU'
export const HIDE_ADD_TO_CALENDAR_MENU = 'HIDE_ADD_TO_CALENDAR_MENU'
export const SET_CURRENT_EVENT_LINKS = 'SET_CURRENT_EVENT_LINKS'